import type { Layout } from '../../../data/types';
import type { PolygonIndex } from '../../../geo/polygonIndex';
import type { Lot, ReservedFootprint } from '../types';
import { obliqueRowLots, type ObliqueRow } from './obliqueRowLots';
import type { SurveyedRow } from './rowTypes';

const ROW = 'damrak-west-dam-papen';

/** Keep the recorded quay fronts while sharing an estimated plot direction across its bends. */
export function fitDamrakWestPlots(
  lots: readonly Lot[],
  readings: readonly SurveyedRow[],
  layout: Layout,
  buildable: PolygonIndex,
  reserved: readonly ReservedFootprint[]
): readonly Lot[] {
  const row = readings.find((r) => r.id === ROW) as ObliqueRow | undefined;
  if (!row?.plotAxis) return lots;
  const other = lots.filter((l) => l.reconstruction?.row !== ROW);
  // The opposite Nieuwendijk homes and every other recorded row keep their footprints.
  const fixed: ReservedFootprint[] = other.map((l) => ({
    id: `surveyed:${l.reconstruction!.id}`,
    polygon: { outer: [...l.corners], holes: [] },
  }));
  const fitted = obliqueRowLots(
    [{ ...row, shear: 0 }],
    layout,
    buildable,
    [...reserved, ...fixed],
    10_000
  );
  return [...fitted, ...other].map((l, index) => ({ ...l, index }));
}
